<template>
  <div style="position: relative;">
    <el-form ref="specialistCertificateListFilter" :model="specialistCertificateList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="签发年份" prop="formFilter.signYear">
          <el-date-picker class="filter-item" v-model="specialistCertificateList.formFilter.signYearReq"
                          :clearable="true"
            format="yyyy"
            value-format="yyyy"
            type="year" align="left"
            placeholder="签发年份"
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.specialistType">
          <el-select class="filter-item" v-model="specialistCertificateList.formFilter.specialistType" :clearable="true" filterable
            placeholder="类型" :loading="specialistCertificateList.specialistType.impl.loading"
            @visible-change="specialistCertificateList.specialistType.impl.onVisibleChange"
            @change="onSpecialistTypeValueChange">
            <el-option v-for="item in specialistCertificateList.specialistType.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="formFilter.specialistName">
          <el-input class="filter-item" v-model="specialistCertificateList.formFilter.specialistName"
            :clearable="true" placeholder="名称"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetSpecialistCertificateList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshSpecialistCertificateList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" v-id="userInfo.loginName
        ==='admin'"
                   @click="batchRegenerate()">重新生成</el-button>

      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialistCertificate" :data="specialistCertificateList.SpecialistCertificate.impl.dataList" :size="defaultFormItemSize" @sort-change="specialistCertificateList.SpecialistCertificate.impl.onSortChange"
          header-cell-class-name="table-header-gray" @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="specialistCertificateList.SpecialistCertificate.impl.getTableIndex" />

          <el-table-column label="证书名称" prop="certificateName">
          </el-table-column>
          <el-table-column label="证书编号" prop="certificateNo">
          </el-table-column>
          <el-table-column label="签发年份" prop="signYear">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.signYear, 'year')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="专家名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="类型" prop="specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="证书图片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.certificatePhoto, {id: scope.row.id, fieldName: 'certificatePhoto', asImage: true})"
                :preview-src-list="getPictureList(scope.row.certificatePhoto, {id: scope.row.id, fieldName: 'certificatePhoto', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialistCertificateList.SpecialistCertificate.impl.totalCount"
            :current-page="specialistCertificateList.SpecialistCertificate.impl.currentPage"
            :page-size="specialistCertificateList.SpecialistCertificate.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialistCertificateList.SpecialistCertificate.impl.onCurrentPageChange"
            @size-change="specialistCertificateList.SpecialistCertificate.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistCertificateController, DictionaryController } from '@/api';

export default {
  name: 'specialistCertificateList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      specialistCertificateList: {
        formFilter: {
          signYearReq: undefined,
          specialistType: undefined,
          specialistName: undefined
        },
        formFilterCopy: {
          signYearReq: undefined,
          specialistType: undefined,
          specialistName: undefined
        },
        SpecialistCertificate: {
          impl: new TableWidget(this.loadSpecialistCertificateWidgetData, this.loadSpecialistCertificateVerify, true, false)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        isInit: false
      },
      userInfo: {},
      multiSelect: []

    }
  },
  methods: {
    handleSelectionChange (val) {
      this.multiSelect = val
    },
    onResetSpecialistCertificateList () {
      this.$refs.specialistCertificateListFilter.resetFields();
      this.refreshSpecialistCertificateList(true);
    },
    /**
     * 科特派证书数据获取函数，返回Promise
     */
    loadSpecialistCertificateWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        specialistCertificateDtoFilter: {
          ...this.specialistCertificateList.formFilter
        },
        orderParam: [{
          fieldName: 'createTime',
          asc: false
        }]
      }
      return new Promise((resolve, reject) => {
        SpecialistCertificateController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    batchRegenerate () {
      let param = {
        specialistCertificateList: this.multiSelect,
        specialistCertificateDtoFilter: {
          ...this.specialistCertificateList.formFilter
        }
      }
      SpecialistCertificateController.batchRegenerate(this, param).then(res => {
        this.refreshSpecialistCertificateList();
      })
    },
    /**
     * 科特派证书数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistCertificateVerify () {
      return true;
    },
    /**
     * 类型(1个人2团队3法人)下拉数据获取函数
     */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型(1个人2团队3法人)选中值改变
     */
    onSpecialistTypeValueChange (value) {
    },
    /**
     * 更新科特派证书列表
     */
    refreshSpecialistCertificateList (reloadData = false) {
      if (reloadData) {
        this.specialistCertificateList.SpecialistCertificate.impl.refreshTable(true, 1);
      } else {
        this.specialistCertificateList.SpecialistCertificate.impl.refreshTable();
      }
      if (!this.specialistCertificateList.isInit) {
        // 初始化下拉数据
      }
      this.specialistCertificateList.isInit = true;
    },
    onResume () {
      this.refreshSpecialistCertificateList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshSpecialistCertificateList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
  },
  watch: {
  }
}
</script>
